import React from 'react';
import Navbar from './components/navbar';
import Home from './pages/home';
import Booking from './pages/booking';
import Videos from './pages/videos';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TrackStatus from './pages/track';
import Orders from './pages/orders';
import Login from './pages/login';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem('token'); // Check for token in localStorage

  if (!token) {
    return <Navigate to="/login" replace />; // Redirect to login if no token
  }

  return element;
};

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/track" element={<TrackStatus />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/login" element={<Login />} />
        <Route path="/orders" element={<ProtectedRoute element={<Orders />} />} />
      </Routes>
    </Router>
  );
}

export default App;

